

































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { parse, ParseError, ParseResult } from "papaparse";
import Page from "@/components/layout/page.vue";
import { Team, User } from "@/swagger/models";
import { teamService } from "@/services/team";
import team from "@/views/users/team.vue";
import { UserCreateDTO, userService } from "@/services/user";
import alert from "@/components/misc/alert.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

interface CsvRecord {
    firstname?: string;
    lastname?: string;
    email?: string;
    teams?: string;
    selected: boolean;
    mappedTeams: Team[];
    errors: string[];
    user?: User;
}

@Component({
    name: "user-csv-import",
    components: { Page, alert },
})
export default class UserCsvImport extends Vue {
    // csvFile: File = null;
    teams: Team[] = [];
    csvData: CsvRecord[] = [];
    csvError: Error = null;
    importProgress = 0; // 0-1
    importing = false;
    activateImportedUsers: boolean = true;

    get selectedUsers() {
        return this.csvData.filter((r) => r.selected);
    }

    get allRecordsSelected() {
        return this.selectedUsers.length === this.csvData.length;
    }

    async parseCsvFile(file: File) {
        try {
            if (!file) {
                this.csvData.length = 0;
                this.csvError = null;
                return;
            }
            const res: ParseResult<CsvRecord> = await new Promise((complete, error) => {
                parse<CsvRecord>(file, {
                    header: true,
                    skipEmptyLines: true,
                    transformHeader: (header) => header.toLowerCase().replace(/ /g, ""),
                    transform: (value) => value.trim(),
                    complete,
                    error,
                });
            });

            for (const error of res.errors) {
                this.$tosti.warning({ message: error.message });
                console.warn(error);
            }

            // Load teams
            await this.loadTeams();

            // Map the teams so we can display them
            res.data.forEach(
                // A work of art.
                // prettier-ignore
                (r) => (r.mappedTeams = this.teams.filter((t) => r.teams && r.teams.split(" ").map(tid=>parseInt(tid)).includes(t.id))),
            );

            // Add errors to records
            res.data.forEach((r, i) => (r.errors = res.errors.filter((e) => e.row === i).map((e) => e.message)));

            // Add errors for the missing teams
            res.data.forEach((r) => {
                if (!r.teams) return;
                r.teams
                    .split(" ")
                    .map((tid) => parseInt(tid))
                    .forEach((teamId) => {
                        if (!r.mappedTeams.some((t) => t.id === teamId))
                            r.errors.push(`No team with ID ${teamId} could be found`);
                    });
            });

            // Add the selected flag to all records as they don't actually have them
            res.data.forEach((r) => {
                r.selected = r.errors.length === 0;
            });

            this.csvData = res.data;
            this.csvError = null;
        } catch (e) {
            console.warn(e);
            this.csvError = e;
        }
    }

    async loadTeams() {
        this.teams = await teamService.find({
            params: {
                customer: this.$context.customer.id,
            },
        });
    }

    toggleSelectAll() {
        const shouldSelect = !this.allRecordsSelected;
        this.csvData.forEach((r) => (r.selected = shouldSelect));
    }

    async importUsers() {
        let newUsers = 0;
        this.importing = true;
        const usersToImport = this.selectedUsers;
        for (let [i, userData] of usersToImport.entries()) {
            this.importProgress = ((i + 1) / usersToImport.length) * 100;
            if (userData.user) continue; // already imported
            if (userData.errors.length) continue;
            try {
                // Todo: pass in activate boolean
                const user = await userService.create(
                    {
                        firstName: userData.firstname,
                        lastName: userData.lastname,
                        email: userData.email,
                        customerId: this.$context.customer.id,
                        activate: this.activateImportedUsers,
                    } as Partial<UserCreateDTO>, // `activate` is not in User
                    null,
                    false,
                );
                userData.user = user;
                userData.selected = false;

                for (let team of userData.mappedTeams) {
                    await teamService.addUser(team.id, user.id, null, false);
                }

                newUsers++;
            } catch (e) {
                userData.errors.push(e.response?.data?.message || e.message);
                userData.selected = false;
            }
        }

        this.$tosti.success({ message: `Successfully imported ${newUsers} users` });

        this.importing = false;
        this.importProgress = 0;
    }
}
